<!-- src/components/portafolio/FashionStore.vue -->
<template>
  <div class="fashion-store">
    <!-- Botón de regreso -->
    <v-btn fab small class="back-button" @click="$router.push('/portafolio')">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <!-- Header con navegación REDISEÑADO - Estilo Premium -->
    <v-app-bar dark app height="70" class="premium-header">
      <!-- Logo a la izquierda -->
      <div class="logo-container">
        <div class="logo-icon">
          <v-icon size="24">mdi-shopping</v-icon>
        </div>
        <span class="logo-text">FASHION<span class="logo-highlight">STORE</span></span>
      </div>

      <!-- Menú central -->
      <div class="nav-menu d-none d-md-flex">
        <a href="#" class="nav-item" @click.prevent="scrollToTop">Inicio</a>
        <a href="#" class="nav-item" @click.prevent="filtrarPorCategoria('Mujer')"
          >Mujer</a
        >
        <a href="#" class="nav-item" @click.prevent="filtrarPorCategoria('Hombre')"
          >Hombre</a
        >
        <a href="#" class="nav-item" @click.prevent="filtrarPorCategoria('Niños')"
          >Niños</a
        >
        <a href="#" class="nav-item" @click.prevent="verOfertas">
          Ofertas
          <span class="nav-badge">Hot</span>
        </a>
        <a href="#" class="nav-item" @click.prevent="scrollToSection('productos')"
          >Productos</a
        >
      </div>

      <v-spacer></v-spacer>

      <!-- Acciones derecha - MI CUENTA PEGADO A LA DERECHA -->
      <div class="actions-menu d-none d-md-flex">
        <button class="action-btn" @click="buscarProducto">
          <v-icon size="20">mdi-magnify</v-icon>
        </button>
        <button class="action-btn" @click="verFavoritos">
          <v-icon size="20">mdi-heart-outline</v-icon>
          <span class="action-badge">12</span>
        </button>
        <button class="action-btn cart-btn" @click="verCarrito">
          <v-icon size="20">mdi-cart-outline</v-icon>
          <span class="action-badge cart-badge">3</span>
        </button>
        <button class="account-btn" @click="miCuenta">
          <v-icon size="18">mdi-account</v-icon>
          Mi cuenta
        </button>
      </div>

      <!-- Botón menú móvil -->
      <button class="mobile-menu-btn hidden-md-and-up" @click="drawer = true">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </v-app-bar>

    <!-- Drawer móvil mejorado -->
    <v-navigation-drawer v-model="drawer" app temporary class="mobile-drawer-premium">
      <div class="drawer-header-premium">
        <div class="drawer-logo">
          <v-icon color="#E91E63">mdi-shopping</v-icon>
          <span>FashionStore</span>
        </div>
        <button class="drawer-close" @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
      <div class="drawer-menu">
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToTop();
          "
        >
          <v-icon>mdi-home</v-icon>
          <span>Inicio</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            filtrarPorCategoria('Mujer');
          "
        >
          <v-icon>mdi-female</v-icon>
          <span>Mujer</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            filtrarPorCategoria('Hombre');
          "
        >
          <v-icon>mdi-male</v-icon>
          <span>Hombre</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            filtrarPorCategoria('Niños');
          "
        >
          <v-icon>mdi-human-baby-changing-table</v-icon>
          <span>Niños</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            verOfertas();
          "
        >
          <v-icon>mdi-sale</v-icon>
          <span>Ofertas</span>
          <span class="drawer-badge">Hot</span>
        </a>
        <a
          href="#"
          class="drawer-item"
          @click="
            drawer = false;
            scrollToSection('productos');
          "
        >
          <v-icon>mdi-tshirt-crew</v-icon>
          <span>Productos</span>
        </a>
      </div>
      <div class="drawer-footer">
        <button class="drawer-account-btn" @click="miCuenta">
          <v-icon>mdi-account</v-icon>
          Mi cuenta
        </button>
      </div>
    </v-navigation-drawer>

    <!-- Hero Section con carrusel -->
    <v-carousel height="550" hide-delimiters class="hero-carousel">
      <v-carousel-item v-for="(slide, i) in slides" :key="i" :src="slide.imagen">
        <v-container fill-height>
          <v-row align="center" justify="center" class="text-center">
            <v-col cols="12" md-8>
              <div class="hero-content">
                <h1 class="display-3 font-weight-bold white--text mb-4">
                  {{ slide.titulo }}
                </h1>
                <h2 class="headline white--text mb-6 font-weight-light">
                  {{ slide.subtitulo }}
                </h2>
                <v-btn
                  :color="slide.color"
                  dark
                  x-large
                  rounded
                  elevation-10
                  @click="verColeccion(slide.coleccion)"
                >
                  <v-icon left>mdi-tag</v-icon>
                  {{ slide.boton }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-carousel-item>
    </v-carousel>

    <!-- Beneficios -->
    <v-container class="mt-n8">
      <v-card elevation="10" class="benefits-card">
        <v-container>
          <v-row>
            <v-col
              v-for="(beneficio, idx) in beneficios"
              :key="idx"
              cols="6"
              md="3"
              class="text-center"
            >
              <div class="benefit-item">
                <v-icon size="40" :color="beneficio.color">{{ beneficio.icono }}</v-icon>
                <h4 class="title mt-2">{{ beneficio.titulo }}</h4>
                <p class="caption grey--text">{{ beneficio.descripcion }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- Categorías destacadas -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Categorías destacadas</h2>
          <p class="subtitle-1 grey--text">Encuentra lo que buscas por categoría</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(categoria, idx) in categorias" :key="idx" cols="6" sm="4" md="2">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 8 : 2"
              class="category-card text-center pa-3"
              :class="{ 'category-card-hover': hover }"
              @click="filtrarPorCategoria(categoria.nombre)"
            >
              <v-icon size="48" :color="hover ? '#E91E63' : '#666'">
                {{ categoria.icono }}
              </v-icon>
              <p class="mt-2 mb-0 font-weight-bold caption">{{ categoria.nombre }}</p>
              <span class="caption grey--text">{{ categoria.cantidad }} productos</span>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Productos destacados -->
    <v-container id="productos" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Productos destacados</h2>
          <p class="subtitle-1 grey--text">Lo último en moda y tendencias</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          v-for="producto in productosDestacados"
          :key="producto.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="product-card"
              :class="{ 'product-card-hover': hover }"
            >
              <div class="product-badge" v-if="producto.oferta">
                <v-chip small color="#E91E63" dark>-{{ producto.descuento }}%</v-chip>
              </div>
              <div class="product-badge-left" v-if="producto.nuevo">
                <v-chip small color="#4CAF50" dark>Nuevo</v-chip>
              </div>

              <v-img :src="producto.imagen" height="280" class="product-image">
                <div class="product-overlay" v-if="hover">
                  <div class="overlay-buttons">
                    <v-btn
                      fab
                      small
                      dark
                      color="#E91E63"
                      class="mr-2"
                      @click.stop="verProducto(producto)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      fab
                      small
                      dark
                      color="#E91E63"
                      @click.stop="agregarFavorito(producto)"
                    >
                      <v-icon>mdi-heart</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-img>

              <v-card-title class="pb-0 text-subtitle-1 font-weight-bold">
                {{ producto.nombre }}
              </v-card-title>

              <v-card-text>
                <div class="d-flex align-center mb-2">
                  <v-rating
                    v-model="producto.rating"
                    readonly
                    dense
                    half-increments
                    color="#FFD700"
                    size="16"
                  ></v-rating>
                  <span class="ml-2 caption grey--text">({{ producto.reviews }})</span>
                </div>

                <div class="d-flex align-center justify-space-between">
                  <div>
                    <span class="title font-weight-bold" style="color: #e91e63">
                      S/ {{ producto.precio }}
                    </span>
                    <span v-if="producto.precio_anterior" class="caption grey--text ml-2">
                      <s>S/ {{ producto.precio_anterior }}</s>
                    </span>
                  </div>
                  <div class="d-flex align-center">
                    <v-icon small class="mr-1" color="#E91E63">mdi-tag</v-icon>
                    <span class="caption">{{ producto.categoria }}</span>
                  </div>
                </div>

                <div class="d-flex align-center mt-2">
                  <v-icon x-small class="mr-1">mdi-palette</v-icon>
                  <span class="caption">Colores: {{ producto.colores.join(", ") }}</span>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  block
                  color="#E91E63"
                  dark
                  rounded
                  @click.stop="agregarAlCarrito(producto)"
                >
                  <v-icon left>mdi-cart-plus</v-icon>
                  Agregar al carrito
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-8">
        <v-col cols="auto">
          <v-btn color="#E91E63" outlined large rounded @click="verTodosProductos">
            Ver todos los productos
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- Banner de ofertas -->
    <v-container class="mt-12">
      <v-card color="linear-gradient(135deg, #E91E63 0%, #FF6090 100%)" dark class="pa-8">
        <v-row align="center">
          <v-col cols="12" md="8">
            <h2 class="display-1 font-weight-bold mb-4">¡Ofertas de temporada!</h2>
            <p class="headline font-weight-light mb-4">
              Hasta 50% de descuento en toda la colección de verano
            </p>
            <p class="subtitle-1 mb-4">
              Aprovecha las mejores ofertas antes de que se acaben
            </p>
            <v-btn color="#1A1A1A" dark x-large rounded @click="verOfertas">
              Ver ofertas
            </v-btn>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            <v-icon size="120">mdi-tag</v-icon>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- Colecciones -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Colecciones exclusivas</h2>
          <p class="subtitle-1 grey--text">Descubre nuestras colecciones especiales</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(coleccion, idx) in colecciones" :key="idx" cols="12" md="4">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="collection-card"
              @click="verColeccion(coleccion.nombre)"
            >
              <v-img :src="coleccion.imagen" height="300" class="collection-image">
                <div class="collection-overlay" v-if="hover">
                  <v-btn dark large rounded :color="coleccion.color">
                    Ver colección
                  </v-btn>
                </div>
              </v-img>
              <v-card-title class="justify-center">
                {{ coleccion.nombre }}
              </v-card-title>
              <v-card-text class="text-center">
                {{ coleccion.descripcion }}
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Testimonios -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Opiniones de nuestros clientes</h2>
          <p class="subtitle-1 grey--text">Miles de clientes felices con sus compras</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(testimonio, idx) in testimonios" :key="idx" cols="12" md="4">
          <v-card class="testimonial-card pa-4" elevation="3">
            <v-card-text>
              <v-icon color="#E91E63" size="32" class="mb-2"
                >mdi-format-quote-open</v-icon
              >
              <p class="body-1 font-italic">"{{ testimonio.texto }}"</p>
              <div class="d-flex align-center mt-4">
                <v-avatar size="50">
                  <v-img :src="testimonio.avatar"></v-img>
                </v-avatar>
                <div class="ml-3">
                  <p class="mb-0 font-weight-bold">{{ testimonio.nombre }}</p>
                  <v-rating
                    :value="testimonio.rating"
                    readonly
                    dense
                    small
                    color="#FFD700"
                  ></v-rating>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Instagram feed -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Síguenos en Instagram</h2>
          <p class="subtitle-1 grey--text">@fashionstore_peru</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(img, idx) in instagramFeed" :key="idx" cols="6" sm="4" md="2">
          <v-img
            :src="img"
            height="150"
            class="instagram-img"
            @click="openInstagram(idx)"
          >
            <div class="instagram-overlay">
              <v-icon color="white">mdi-instagram</v-icon>
            </div>
          </v-img>
        </v-col>
      </v-row>
    </v-container>

    <!-- Newsletter -->
    <v-container class="mt-12">
      <v-card color="#1A1A1A" dark class="pa-8 text-center">
        <v-card-title class="display-1 justify-center font-weight-light">
          ¡Suscríbete a nuestro newsletter!
        </v-card-title>
        <v-card-text class="subtitle-1">
          Recibe las últimas tendencias y ofertas exclusivas directamente en tu correo
        </v-card-text>
        <v-form class="mt-4">
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-text-field
                v-model="newsletterEmail"
                label="Tu correo electrónico"
                outlined
                dark
                solo
                placeholder="ejemplo@correo.com"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="#E91E63"
                dark
                x-large
                rounded
                block
                @click="suscribirNewsletter"
              >
                Suscribirme
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <p class="caption mt-4">
          No enviaremos spam. Puedes cancelar tu suscripción en cualquier momento.
        </p>
      </v-card>
    </v-container>

    <!-- Footer -->
    <v-footer color="#1A1A1A" dark class="mt-12">
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-icon large class="mb-2" color="#E91E63">mdi-shopping</v-icon>
            <h3 class="title">FashionStore</h3>
            <p class="caption mt-2">Moda y estilo para todos los gustos desde 2020</p>
            <div class="mt-3">
              <v-btn icon dark class="mr-2">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn icon dark class="mr-2">
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
              <v-btn icon dark class="mr-2">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
              <v-btn icon dark>
                <v-icon>mdi-youtube</v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Categorías</h3>
            <v-list dense dark>
              <v-list-item v-for="cat in categorias.slice(0, 4)" :key="cat.nombre">
                <v-list-item-content class="caption">{{
                  cat.nombre
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Ayuda</h3>
            <v-list dense dark>
              <v-list-item>
                <v-list-item-content>Preguntas frecuentes</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Envíos y devoluciones</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Tallas y medidas</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Contacto</h3>
            <p class="caption">
              <v-icon small class="mr-1">mdi-phone</v-icon> +51 928 180 748<br />
              <v-icon small class="mr-1">mdi-whatsapp</v-icon> +51 987 654 321<br />
              <v-icon small class="mr-1">mdi-email</v-icon> ventas@fashionstore.com
            </p>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Horario</h3>
            <p class="caption">
              Lun - Vie: 9am - 8pm<br />
              Sáb: 10am - 6pm<br />
              Dom: 10am - 2pm
            </p>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <div class="text-center caption">
          © 2024 FashionStore - Todos los derechos reservados. <br />
          "Viste con estilo, vive con pasión"
        </div>
      </v-container>
    </v-footer>

    <!-- Dialog de confirmación -->
    <v-dialog v-model="dialogConfirmacion" max-width="400">
      <v-card>
        <v-card-title class="headline success--text">
          <v-icon left color="success" large>mdi-check-circle</v-icon>
          ¡Producto agregado!
        </v-card-title>
        <v-card-text>
          {{ productoAgregado }} ha sido agregado al carrito de compras. <br /><br />
          ¿Deseas seguir comprando o proceder al pago?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#E91E63" text @click="dialogConfirmacion = false">
            Seguir comprando
          </v-btn>
          <v-btn color="#E91E63" dark @click="irAlCarrito"> Ver carrito </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FashionStore",
  data() {
    return {
      drawer: false,
      dialogConfirmacion: false,
      newsletterEmail: "",
      productoAgregado: "",
      slides: [
        {
          titulo: "Colección Verano 2024",
          subtitulo: "Descubre las últimas tendencias en moda veraniega",
          boton: "Comprar ahora",
          color: "#E91E63",
          coleccion: "Verano",
          imagen: "https://images.unsplash.com/photo-1483985988355-763728e1935b",
        },
        {
          titulo: "Hasta 50% de descuento",
          subtitulo: "En toda la colección de ropa de baño",
          boton: "Ver ofertas",
          color: "#FF9800",
          coleccion: "Ofertas",
          imagen: "https://images.unsplash.com/photo-1445205170230-053b83016050",
        },
        {
          titulo: "Nueva colección",
          subtitulo: "Ropa deportiva de alta calidad",
          boton: "Explorar",
          color: "#4CAF50",
          coleccion: "Deportiva",
          imagen: "https://images.unsplash.com/photo-1483985988355-763728e1935b",
        },
      ],
      beneficios: [
        {
          icono: "mdi-truck-fast",
          titulo: "Envío gratis",
          descripcion: "En compras mayores a S/ 150",
          color: "#E91E63",
        },
        {
          icono: "mdi-credit-card",
          titulo: "Pago seguro",
          descripcion: "100% garantizado",
          color: "#FF9800",
        },
        {
          icono: "mdi-undo",
          titulo: "Devoluciones",
          descripcion: "30 días para cambiar",
          color: "#4CAF50",
        },
        {
          icono: "mdi-headset",
          titulo: "Soporte 24/7",
          descripcion: "Atención personalizada",
          color: "#2196F3",
        },
      ],
      categorias: [
        { nombre: "Vestidos", icono: "mdi-dress", cantidad: 156 },
        { nombre: "Camisas", icono: "mdi-shirt", cantidad: 98 },
        { nombre: "Pantalones", icono: "mdi-trousers", cantidad: 124 },
        { nombre: "Zapatos", icono: "mdi-shoe-heel", cantidad: 87 },
        { nombre: "Accesorios", icono: "mdi-necklace", cantidad: 234 },
        { nombre: "Deportes", icono: "mdi-tshirt-crew", cantidad: 67 },
      ],
      productosDestacados: [
        {
          id: 1,
          nombre: "Vestido Floral Estampado",
          descripcion: "Vestido largo con estampado floral, tela fluida y cómoda",
          precio: 129.9,
          precio_anterior: 199.9,
          oferta: true,
          descuento: 35,
          nuevo: false,
          rating: 4.8,
          reviews: 234,
          categoria: "Vestidos",
          colores: ["Rosado", "Azul", "Blanco"],
          imagen: "https://images.unsplash.com/photo-1539008835657-9e8e9680c956",
        },
        {
          id: 2,
          nombre: "Camisa Blanca Clásica",
          descripcion: "Camisa de algodón, corte slim, ideal para oficina",
          precio: 89.9,
          precio_anterior: null,
          oferta: false,
          nuevo: true,
          rating: 4.9,
          reviews: 567,
          categoria: "Camisas",
          colores: ["Blanco"],
          imagen: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c",
        },
        {
          id: 3,
          nombre: "Jeans Skinny",
          descripcion: "Pantalón jeans elástico en color azul oscuro",
          precio: 119.9,
          precio_anterior: 169.9,
          oferta: true,
          descuento: 29,
          nuevo: false,
          rating: 4.7,
          reviews: 890,
          categoria: "Pantalones",
          colores: ["Azul", "Negro"],
          imagen: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246",
        },
        {
          id: 4,
          nombre: "Zapatillas Deportivas",
          descripcion: "Zapatillas cómodas para running y uso diario",
          precio: 199.9,
          precio_anterior: 299.9,
          oferta: true,
          descuento: 33,
          nuevo: true,
          rating: 4.9,
          reviews: 432,
          categoria: "Zapatos",
          colores: ["Blanco", "Negro", "Rosado"],
          imagen: "https://images.unsplash.com/photo-1542291026-7eec264c27ff",
        },
        {
          id: 5,
          nombre: "Chaqueta de Cuero",
          descripcion: "Chaqueta de cuero ecológico, estilo motoquero",
          precio: 299.9,
          precio_anterior: 449.9,
          oferta: true,
          descuento: 33,
          nuevo: false,
          rating: 4.8,
          reviews: 321,
          categoria: "Chaquetas",
          colores: ["Negro", "Marrón"],
          imagen: "https://images.unsplash.com/photo-1551028719-00167b16eac5",
        },
        {
          id: 6,
          nombre: "Bolso de Mano",
          descripcion: "Bolso elegante de cuero sintético",
          precio: 89.9,
          precio_anterior: null,
          oferta: false,
          nuevo: true,
          rating: 4.6,
          reviews: 198,
          categoria: "Accesorios",
          colores: ["Negro", "Marrón", "Rojo"],
          imagen: "https://images.unsplash.com/photo-1584917865442-de89df76afd3",
        },
        {
          id: 7,
          nombre: "Vestido de Noche",
          descripcion: "Vestido elegante para ocasiones especiales",
          precio: 249.9,
          precio_anterior: 399.9,
          oferta: true,
          descuento: 38,
          nuevo: false,
          rating: 4.9,
          reviews: 156,
          categoria: "Vestidos",
          colores: ["Negro", "Rojo", "Azul"],
          imagen: "https://images.unsplash.com/photo-1496747611176-843222e1e57c",
        },
        {
          id: 8,
          nombre: "Short Deportivo",
          descripcion: "Short cómodo para entrenar",
          precio: 59.9,
          precio_anterior: 89.9,
          oferta: true,
          descuento: 33,
          nuevo: false,
          rating: 4.7,
          reviews: 445,
          categoria: "Deportes",
          colores: ["Negro", "Gris", "Azul"],
          imagen: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b",
        },
      ],
      colecciones: [
        {
          nombre: "Colección Verano",
          descripcion: "Prendas frescas y coloridas para la temporada",
          color: "#E91E63",
          imagen: "https://images.unsplash.com/photo-1483985988355-763728e1935b",
        },
        {
          nombre: "Atardecer Elegante",
          descripcion: "Vestidos y accesorios para ocasiones especiales",
          color: "#FF9800",
          imagen: "https://images.unsplash.com/photo-1496747611176-843222e1e57c",
        },
        {
          nombre: "Active Wear",
          descripcion: "Ropa deportiva de alto rendimiento",
          color: "#4CAF50",
          imagen: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b",
        },
      ],
      testimonios: [
        {
          nombre: "Sofía Ramírez",
          texto:
            "Excelente calidad de los productos, el vestido que compré es hermoso y llegó rápido.",
          rating: 5,
          avatar: "https://randomuser.me/api/portraits/women/1.jpg",
        },
        {
          nombre: "Diego Torres",
          texto:
            "Muy buena atención al cliente y los precios son competitivos. Volveré a comprar.",
          rating: 5,
          avatar: "https://randomuser.me/api/portraits/men/2.jpg",
        },
        {
          nombre: "Valentina López",
          texto: "Me encanta la variedad de ropa que tienen. La página es fácil de usar.",
          rating: 5,
          avatar: "https://randomuser.me/api/portraits/women/3.jpg",
        },
      ],
      instagramFeed: [
        "https://images.unsplash.com/photo-1539008835657-9e8e9680c956",
        "https://images.unsplash.com/photo-1596755094514-f87e34085b2c",
        "https://images.unsplash.com/photo-1541099649105-f69ad21f3246",
        "https://images.unsplash.com/photo-1542291026-7eec264c27ff",
        "https://images.unsplash.com/photo-1551028719-00167b16eac5",
        "https://images.unsplash.com/photo-1584917865442-de89df76afd3",
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    verColeccion(coleccion) {
      alert(`Mostrando colección: ${coleccion}`);
    },
    verOfertas() {
      alert("Mostrando todas las ofertas especiales");
    },
    filtrarPorCategoria(categoria) {
      alert(`Mostrando productos de: ${categoria}`);
    },
    verProducto(producto) {
      alert(`Ver detalles de: ${producto.nombre}`);
    },
    verTodosProductos() {
      alert("Mostrando todos los productos");
    },
    agregarFavorito(producto) {
      alert(`${producto.nombre} agregado a favoritos`);
    },
    agregarAlCarrito(producto) {
      this.productoAgregado = producto.nombre;
      this.dialogConfirmacion = true;
    },
    irAlCarrito() {
      this.dialogConfirmacion = false;
      alert("Redirigiendo al carrito de compras");
    },
    buscarProducto() {
      alert("Abrir buscador");
    },
    verFavoritos() {
      alert("Ver lista de favoritos");
    },
    verCarrito() {
      alert("Ver carrito de compras");
    },
    miCuenta() {
      alert("Ir a mi cuenta");
    },
    openInstagram(index) {
      alert(`Ver imagen ${index + 1} en Instagram`);
    },
    suscribirNewsletter() {
      if (this.newsletterEmail && /.+@.+\..+/.test(this.newsletterEmail)) {
        alert("¡Gracias por suscribirte! Recibirás nuestras ofertas y novedades.");
        this.newsletterEmail = "";
      } else {
        alert("Por favor ingresa un email válido");
      }
    },
  },
};
</script>

<style scoped>
.fashion-store {
  background: #f8f9fa;
  min-height: 100vh;
}

/* ========== BOTÓN DE REGRESO ========== */
.back-button {
  position: fixed;
  top: 85px;
  left: 24px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  color: #e91e63;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.back-button:hover {
  background: #e91e63;
  color: white;
  transform: translateX(-3px);
}

/* ========== HEADER PREMIUM ========== */
.premium-header {
  background: rgba(10, 10, 10, 0.96) !important;
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(233, 30, 99, 0.2);
  height: 70px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}

.premium-header .v-toolbar__content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 32px;
  height: 70px !important;
  display: flex;
  align-items: center;
}

/* Logo */
.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #e91e63, #ff6090);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(233, 30, 99, 0.3);
}

.logo-icon .v-icon {
  color: white;
}

.logo-text {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #fff, #ccc);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

.logo-highlight {
  color: #e91e63;
  background: none;
  -webkit-background-clip: unset;
  background-clip: unset;
}

/* Menú central */
.nav-menu {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 12px;
  border-radius: 50px;
  margin: 0 24px;
}

.nav-item {
  position: relative;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 0.85rem;
  padding: 8px 16px;
  border-radius: 40px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-item:hover {
  color: #e91e63;
  background: rgba(233, 30, 99, 0.12);
}

.nav-badge {
  background: #e91e63;
  color: white;
  font-size: 0.65rem;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 600;
}

/* Acciones derecha - MI CUENTA PEGADO A LA DERECHA */
.actions-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.action-btn {
  position: relative;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: rgba(233, 30, 99, 0.2);
  color: #e91e63;
  transform: translateY(-2px);
}

.action-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #e91e63;
  color: white;
  font-size: 0.65rem;
  font-weight: 600;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-badge {
  background: #ff9800;
}

.account-btn {
  background: linear-gradient(135deg, #e91e63, #ff6090);
  border: none;
  padding: 6px 18px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.account-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(233, 30, 99, 0.4);
}

/* Botón menú móvil */
.mobile-menu-btn {
  background: transparent;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.mobile-menu-btn span {
  width: 22px;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.mobile-menu-btn:hover span {
  background: #e91e63;
}

/* ========== DRAWER MÓVIL PREMIUM ========== */
.mobile-drawer-premium {
  background: #111;
  width: 280px;
}

.drawer-header-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.drawer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
}

.drawer-close {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
}

.drawer-close:hover {
  background: rgba(233, 30, 99, 0.3);
}

.drawer-menu {
  padding: 16px;
}

.drawer-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  margin: 4px 0;
  border-radius: 12px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  cursor: pointer;
}

.drawer-item:hover {
  background: rgba(233, 30, 99, 0.15);
  color: #e91e63;
}

.drawer-badge {
  background: #e91e63;
  color: white;
  font-size: 0.65rem;
  padding: 2px 10px;
  border-radius: 20px;
  margin-left: auto;
}

.drawer-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
}

.drawer-account-btn {
  width: 100%;
  background: linear-gradient(135deg, #e91e63, #ff6090);
  border: none;
  padding: 10px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}

/* ========== RESTO DE ESTILOS ========== */
.hero-carousel {
  margin-top: -70px;
}

.hero-content {
  background: rgba(0, 0, 0, 0.4);
  padding: 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.benefits-card {
  margin-top: -40px;
  background: white;
  border-radius: 20px;
  position: relative;
  z-index: 10;
}

.benefit-item {
  padding: 15px;
}

.category-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  height: 100%;
}

.category-card-hover {
  transform: translateY(-5px);
  background: #fce4ec;
}

.product-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  height: 100%;
}

.product-card-hover {
  transform: translateY(-8px);
}

.product-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}

.product-badge-left {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}

.product-image {
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
}

.product-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.overlay-buttons {
  display: flex;
  gap: 10px;
}

.collection-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
}

.collection-image {
  position: relative;
}

.collection-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.testimonial-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 15px;
}

.testimonial-card:hover {
  transform: translateY(-5px);
}

.instagram-img {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}

.instagram-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.instagram-img:hover .instagram-overlay {
  opacity: 1;
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.category-card,
.product-card,
.collection-card,
.testimonial-card {
  animation: fadeIn 0.6s ease;
}

/* Responsive */
@media (max-width: 960px) {
  .premium-header .v-toolbar__content {
    padding: 0 20px;
  }
}

@media (max-width: 600px) {
  .display-3 {
    font-size: 1.8rem !important;
  }

  .display-1 {
    font-size: 1.8rem !important;
  }

  .hero-content {
    padding: 20px;
  }

  .benefits-card {
    margin-top: -20px;
  }

  .product-card {
    margin-bottom: 16px;
  }

  .logo-text {
    font-size: 0.9rem;
  }

  .logo-icon {
    width: 30px;
    height: 30px;
  }

  .back-button {
    top: 80px;
    left: 16px;
  }
}

/* Scroll personalizado */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #e91e63;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #c2185b;
}
</style>
